/**
 * 个人中心服务
 * created by chenhao 2017-12-5 10:35:43
 */
'use strict';
angular.module('zoneServiceModule', ['uploadHeaderModule', 'modifyChartInfoModule', 'newCropperHeaderlogoModule'])
    .factory('zoneService', ['$modal', '$q', function($modal, $q) {
        return {

            /**
             * [uploadHeader description] 上传头像
             * @return {[type]} [description]
             */
            uploadHeader: function(orginalHeader, success) {
                var modalInstance = $modal.open({
                    templateUrl: './myZone/personalInfo/info/service/uploadHeader/uploadHeader.html',
                    windowClass: 'uploadHeader',
                    backdrop: false,
                    controller: 'uploadHeaderCtrl',
                    resolve: {
                        item: function() {
                            return {
                                url: orginalHeader
                            };
                        }
                    }
                });
                return modalInstance.result.then(function() {
                    success();
                });
            },

            /**
             * [modifyChartInfo description]
             * @param  {[type]} chartInfo [description] 
             * @param  {[type]} type      [description] 电话号码，邮箱
             * @param  {[type]} success      [description] 成功后的回调
             * @return {[type]}           [description]
             */
            modifyChartInfo: function(chartInfo, type, success) {
                var modalInstance = $modal.open({
                    templateUrl: './myZone/personalInfo/info/service/modifyChartInfo/modifyChartInfo.html',
                    windowClass: 'modifyChartInfo',
                    backdrop: false,
                    controller: 'modifyChartInfoCtrl',
                    resolve: {
                        item: function() {
                            return {
                                info: chartInfo,
                                type: type
                            };
                        }
                    }
                });
                return modalInstance.result.then(function() {
                    success();
                });
            },

            /**
             * [newCropper description 裁剪图片new]
             * @param {[string]} src [description] 图片路径
             * @param {[pictureSize]} pictureSize [description] 裁剪尺寸
             * @return {[type]} [description]
             */
            newCropperHeaderlogo: function(src, pictureSize) {
                var deffer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: './myZone/personalInfo/info/service/newCropperHeaderlogo/newCropperHeaderlogo_tpl.html',
                    windowClass: 'newCropperHeaderlogo',
                    backdrop: false,
                    controller: 'newCropperHeaderlogoCtrl',
                    resolve: {
                        params: function() {
                            return {
                                imgSrc: src,
                                pictureSize: {
                                    width: pictureSize.split(',')[0],
                                    height: pictureSize.split(',')[1]
                                }
                            };
                        }
                    }
                });
                modalInstance.result.then(function(result) {
                    deffer.resolve(result);
                }, function() {
                    deffer.reject(); // 点击关闭时的回调
                });
                return deffer.promise;
            },
        };
    }]);
